import React from 'react';

const Header = () => {
  return (
    <div className="bg-white shadow-md p-6 flex justify-center w-full">
      <img 
        src="/sds_logo_eng_cmyk.svg" 
        alt="CityU Student Development Services" 
        className="h-16 w-auto"
      />
    </div>
  );
};

export default Header;
